export { ScrollUpBar, type ScrollUpBarProps } from "./scroll-up-bar";
export { ScrollUpBar as default } from "./scroll-up-bar";
